/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import { toast } from 'react-toastify';
import GetchkdUserForm from './GetchkdUserForm';
import { editGetchkdUser } from '../../../../../../services/user/GetchkdUser';
import { getAllGetchkdUsers } from '../../../../../../store/reducers/getchkdUser/getchkdUserAction';

const GetchkdUserEdit = ({ handleClose, selectedGetchkdUser }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ getChkdID, detailName, detailValue }, { setSubmitting }) => {
        setSubmitting(true)
        try {
            await editGetchkdUser({
                getChkdID, accountDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Getchkd User was edited successfully');
            handleClose();
            await dispatch(getAllGetchkdUsers()).unwrap();
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)

            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Getchkd User Edit</Typography>
            <Formik
                initialValues={{
                    getChkdID: selectedGetchkdUser.getChkdID,
                    detailName: selectedGetchkdUser?.accountDetails?.[0]?.detailName ?? "",
                    detailValue: selectedGetchkdUser?.accountDetails?.[0]?.detailValue ?? ""



                }}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    setSubmitting(true)
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (

                    <GetchkdUserForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched}
                    />
                )}
            </Formik>
        </>
    )

}


export default GetchkdUserEdit;
